import Icons from '../svgs/icons';
import React, { useState } from 'react';

const Accordion = ({ data }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full md:gap-[19px] gap-5 flex flex-col">
      {data?.map((item, index) => (
        <div
          key={index}
          className="border border-[#B6C0F3] md:rounded-[10px] rounded-[10px] bg-[#FAFBFE] dark:bg-shoorah-darkBgTabColor"
        >
          <div
            className="flex justify-between items-center md:py-[14px] md:px-5 px-3 py-2 cursor-pointer bg-[#FAFBFE] dark:bg-shoorah-darkBgTabColor md:rounded-[10px] rounded-[10px]"
            onClick={() => toggleAccordion(index)}
          >
            <h2 className="text-[14px] text-[#606060] dark:text-shoorah-darkBg line-clamp-1">
              {item?.faqQuestion}
            </h2>
            <Icons.arrowDownIcon
              className={`w-5 h-5 transform transition-transform ${
                openIndex === index ? 'rotate-180' : ''
              }`}
            />
          </div>
          {openIndex === index && (
            <div className="md:text-[14px] text-[12px] bg-[#FAFBFE] md:p-4 px-3 py-2 md:rounded-[10px] rounded-[10px] text-[#606060] dark:text-shoorah-darkBg dark:bg-shoorah-darkBgTabColor">
              <p>{item?.faqAnswer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
